/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CategoryDto {
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Category name
   * @example "Food"
   */
  name: string;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

export interface CreateCategoryDto {
  /**
   * Category name
   * @example "Food"
   */
  name: string;
}

export interface CreateManualTransferRecordDto {
  /**
   * Amount to split off from the default record (minor currency units)
   * @example 500
   */
  amount: number;
  /**
   * Uuid of the category to assign to this part of the transfer
   * @example "00000000-0000-0000-0000-000000000000"
   */
  categoryId: string;
  /**
   * Comma separated description of this part of the transfer
   * @example "Netflix, Subscription"
   */
  description?: string;
}

export interface CreatePatternDto {
  /**
   * Transfer amount this pattern additionally matches on (minor currency units). Omit to match any amount.
   * @example 1599
   */
  amount?: number;
  /**
   * Uuid of the category to assign
   * @example "00000000-0000-0000-0000-000000000000"
   */
  categoryId: string;
  /**
   * Comma separated description applied to the transfer default record
   * @example "Netflix, Subscription"
   */
  description?: string;
  /**
   * Transfer party this pattern matches (exact, normalized name)
   * @example "Netflix"
   */
  party: string;
}

export interface CreateProjectDto {
  /**
   * Project name
   * @example "My Expenses"
   */
  name: string;
}

export interface CreateReceiptDto {
  /**
   * Receipt QR code value
   * @example "O-FE7EB8EDCE204904BEB8EDCE20690405"
   */
  receiptCode: string;
}

export interface CreateTransferDto {
  /**
   * Transfer total amount
   * @example 700
   */
  amount: number;
  /**
   * Uuid of the category to assign to the default transfer record
   * @example "00000000-0000-0000-0000-000000000000"
   */
  categoryId?: string;
  /**
   * Transfer date
   * @example "2025-12-31T17:28:37.800Z"
   */
  date: string;
  /**
   * Comma separated description of the transfer
   * @example "Mrkva, Hrach"
   */
  description?: string;
  /**
   * Transfer party, as entered by the user
   * @example "SK3502000000000048134112"
   */
  rawParty: string;
  /**
   * Transfer payment type
   * @example "Debit"
   */
  type: CreateTransferDtoTypeEnum;
}

/**
 * Transfer payment type
 * @example "Debit"
 */
export enum CreateTransferDtoTypeEnum {
  Debit = "Debit",
  Credit = "Credit",
}

export interface CreateTransferRecordDto {
  /**
   * Uuid of the category to assign to the selected items
   * @example "00000000-0000-0000-0000-000000000000"
   */
  categoryId: string;
  /**
   * Uuids of the selected receipt items
   * @example ["00000000-0000-0000-0000-000000000000"]
   */
  itemUuids: string[];
  /**
   * Uuid of the matched receipt
   * @example "00000000-0000-0000-0000-000000000000"
   */
  receiptId: string;
}

export interface ImportTransfersResultDto {
  /**
   * Number of entries imported as new transfers
   * @example 38
   */
  imported: number;
  /**
   * Number of entries skipped (already imported, or missing a required ref/date)
   * @example 4
   */
  skipped: number;
  /**
   * Total number of entries found in the uploaded file
   * @example 42
   */
  total: number;
}

export interface NamePatternDto {
  /**
   * Base name
   * @example "SuperButterExtra"
   */
  baseName: string;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Override name
   * @example "Butter"
   */
  overrideName: string;
  /**
   * Pattern type
   * @example "Item"
   */
  type: NamePatternDtoTypeEnum;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Pattern type
 * @example "Item"
 */
export enum NamePatternDtoTypeEnum {
  Party = "Party",
  Item = "Item",
}

export interface NamePatternListDto {
  /** Category assigned to this override name via the item-category patterns, if any (Item type only) */
  category?: CategoryDto | null;
  /**
   * Count of base names related to this override
   * @example 5
   */
  count: number;
  /**
   * Overridden name
   * @example "Butter"
   */
  overrideName: string;
}

export interface NamePatternPageDto {
  data: NamePatternListDto[];
  /**
   * Total number of override groups matching the filter
   * @example 42
   */
  total: number;
}

export interface PatternDto {
  /**
   * Transfer amount this pattern additionally matches on (minor currency units). Absent matches any amount.
   * @example 1599
   */
  amount?: number | null;
  /** Category assigned by this pattern */
  category: CategoryDto;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Comma separated description applied to the transfer default record
   * @example "Netflix, Subscription"
   */
  description?: string | null;
  /**
   * Transfer party this pattern matches (exact, normalized name)
   * @example "Netflix"
   */
  party: string;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

export interface ProjectDto {
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Project name
   * @example "My expenses"
   */
  name: string;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

export interface ReceiptBaseDto {
  /**
   * Receipt total amount (in minor currency units, e.g., cents)
   * @example 1240
   */
  amount: number | null;
  /** Transfer this receipt is assigned to, if any */
  assignedTransfer?: TransferSummaryDto;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Receipt date
   * @format date-time
   */
  date: string | null;
  /**
   * Receipt QR code value
   * @example "O-FE7EB8EDCE204904BEB8EDCE20690405"
   */
  extId: string;
  /**
   * Receipt seller party
   * @example "Tesco"
   */
  party: string | null;
  /**
   * Receipt QR code value
   * @example "Created"
   */
  status: ReceiptBaseDtoStatusEnum;
  /**
   * Receipt total items count
   * @example 5
   */
  totalItems?: number;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Receipt QR code value
 * @example "Created"
 */
export enum ReceiptBaseDtoStatusEnum {
  Created = "Created",
  Failed = "Failed",
  Loaded = "Loaded",
  Processed = "Processed",
}

export interface ReceiptDto {
  /**
   * Receipt total amount (in minor currency units, e.g., cents)
   * @example 1240
   */
  amount: number | null;
  /** Transfer this receipt is assigned to, if any */
  assignedTransfer?: TransferSummaryDto;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Receipt date
   * @format date-time
   */
  date: string | null;
  /**
   * Receipt QR code value
   * @example "O-FE7EB8EDCE204904BEB8EDCE20690405"
   */
  extId: string;
  /** Receipt items */
  items: ReceiptItemDto[];
  /**
   * Receipt seller party
   * @example "Tesco"
   */
  party: string | null;
  /**
   * Receipt QR code value
   * @example "Created"
   */
  status: ReceiptDtoStatusEnum;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Receipt QR code value
 * @example "Created"
 */
export enum ReceiptDtoStatusEnum {
  Created = "Created",
  Failed = "Failed",
  Loaded = "Loaded",
  Processed = "Processed",
}

export interface ReceiptItemAssignDiscountDto {
  /**
   * Discount receipt item UUID
   * @example "00000000-0000-0000-0000-000000000000"
   */
  discountItemUuid: string;
}

export interface ReceiptItemDto {
  /**
   * Total amount of all items (in minor currency units, e.g., cents)
   * @example 200
   */
  amount: number;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Discount applied on items (in minor currency units, e.g., cents)
   * @example 20
   */
  discount: number;
  /**
   * Item name
   * @example "Milk"
   */
  name: string;
  /**
   * Item quantity
   * @example 2
   */
  quantity: number;
  /**
   * Item type
   * @example "Item"
   */
  type: ReceiptItemDtoTypeEnum;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Item type
 * @example "Item"
 */
export enum ReceiptItemDtoTypeEnum {
  Item = "Item",
  Discount = "Discount",
}

export interface ReceiptItemUpdateDto {
  /**
   * Name of the receipt items
   * @example "Bananas"
   */
  name?: string;
  /**
   * Quantity of the items
   * @example 1
   */
  quantity?: number;
}

export interface SuggestedReceiptDto {
  /**
   * Receipt total amount (in minor currency units, e.g., cents)
   * @example 1240
   */
  amount: number | null;
  /** Transfer this receipt is assigned to, if any */
  assignedTransfer?: TransferSummaryDto;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Receipt date
   * @format date-time
   */
  date: string | null;
  /**
   * Receipt QR code value
   * @example "O-FE7EB8EDCE204904BEB8EDCE20690405"
   */
  extId: string;
  /** Receipt items, each carrying a suggested category if one was found */
  items: SuggestedReceiptItemDto[];
  /**
   * Receipt seller party
   * @example "Tesco"
   */
  party: string | null;
  /**
   * Receipt QR code value
   * @example "Created"
   */
  status: SuggestedReceiptDtoStatusEnum;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Receipt QR code value
 * @example "Created"
 */
export enum SuggestedReceiptDtoStatusEnum {
  Created = "Created",
  Failed = "Failed",
  Loaded = "Loaded",
  Processed = "Processed",
}

export interface SuggestedReceiptItemDto {
  /**
   * Total amount of all items (in minor currency units, e.g., cents)
   * @example 200
   */
  amount: number;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Discount applied on items (in minor currency units, e.g., cents)
   * @example 20
   */
  discount: number;
  /**
   * Item name
   * @example "Milk"
   */
  name: string;
  /**
   * Item quantity
   * @example 2
   */
  quantity: number;
  /** Category suggested for this item, based on past usage. Absent if unmapped. */
  suggestedCategory?: CategoryDto;
  /**
   * Item type
   * @example "Item"
   */
  type: SuggestedReceiptItemDtoTypeEnum;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Item type
 * @example "Item"
 */
export enum SuggestedReceiptItemDtoTypeEnum {
  Item = "Item",
  Discount = "Discount",
}

export interface TransferDto {
  /**
   * Transfer total amount
   * @example 700
   */
  amount: number;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * Transfer date
   * @format date-time
   * @example "2025-12-31T17:28:37.800Z"
   */
  date: string;
  /**
   * Date of deletion
   * @format date-time
   */
  deletedAt?: string;
  /**
   * Transfer external ID
   * @example "2023609241973"
   */
  extId?: string;
  /**
   * Transfer payment method
   * @example "Card"
   */
  method: TransferDtoMethodEnum;
  /**
   * Transfer party
   * @example "Generali"
   */
  party?: string;
  /**
   * Transfer party (raw as extracted)
   * @example "SK3502000000000048134112"
   */
  rawParty: string;
  /** Receipt assigned to this transfer, if any */
  receipt?: ReceiptDto | null;
  /** Transfer payment type */
  records: TransferRecordDto[];
  /**
   * Transfer payment type
   * @example "Debit"
   */
  type: TransferDtoTypeEnum;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Transfer payment method
 * @example "Card"
 */
export enum TransferDtoMethodEnum {
  Cash = "Cash",
  Card = "Card",
}

/**
 * Transfer payment type
 * @example "Debit"
 */
export enum TransferDtoTypeEnum {
  Debit = "Debit",
  Credit = "Credit",
}

export interface TransferRecordDto {
  /**
   * Transfer total amount
   * @example 700
   */
  amount: number;
  /** First transfer record is default and can be split */
  category: CategoryDto;
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * First transfer record is default and can be split
   * @example true
   */
  default: boolean;
  /**
   * Date of deletion
   * @format date-time
   */
  deletedAt?: string;
  /**
   * Items within this record
   * @example ["Mrkva","Hrach"]
   */
  items: string[];
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

export interface TransferStatsDto {
  /**
   * Sum of Credit transfer amounts matching the applied filters
   * @example 3000
   */
  totalCredit: number;
  /**
   * Sum of Debit transfer amounts matching the applied filters
   * @example 12000
   */
  totalDebit: number;
}

export interface TransferSummaryDto {
  /**
   * Transfer total amount
   * @example 700
   */
  amount: number;
  /**
   * Transfer date
   * @format date-time
   * @example "2025-12-31T17:28:37.800Z"
   */
  date: string;
  /**
   * Transfer payment method
   * @example "Card"
   */
  method: TransferSummaryDtoMethodEnum;
  /**
   * Transfer party
   * @example "Generali"
   */
  party?: string;
  /**
   * Transfer party (raw as extracted)
   * @example "SK3502000000000048134112"
   */
  rawParty: string;
  /**
   * Transfer payment type
   * @example "Debit"
   */
  type: TransferSummaryDtoTypeEnum;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

/**
 * Transfer payment method
 * @example "Card"
 */
export enum TransferSummaryDtoMethodEnum {
  Cash = "Cash",
  Card = "Card",
}

/**
 * Transfer payment type
 * @example "Debit"
 */
export enum TransferSummaryDtoTypeEnum {
  Debit = "Debit",
  Credit = "Credit",
}

export interface UpdateCategoryDto {
  /**
   * Category name
   * @example "Food"
   */
  name: string;
}

export interface UpdatePatternDto {
  /**
   * Transfer amount this pattern additionally matches on (minor currency units). Omit to match any amount.
   * @example 1599
   */
  amount?: number;
  /**
   * Uuid of the category to assign
   * @example "00000000-0000-0000-0000-000000000000"
   */
  categoryId?: string;
  /**
   * Comma separated description applied to the transfer default record
   * @example "Netflix, Subscription"
   */
  description?: string;
  /**
   * Transfer party this pattern matches (exact, normalized name)
   * @example "Netflix"
   */
  party?: string;
}

export interface UpdateReceiptDto {
  /**
   * Receipt party
   * @example "Tesco"
   */
  party: string;
}

export interface UpdateTransferDto {
  /**
   * Transfer total amount
   * @example 700
   */
  amount?: number;
  /**
   * Transfer date
   * @example "2025-12-31T17:28:37.800Z"
   */
  date?: string;
  /**
   * Transfer party (normalized). Renaming updates all transfers sharing the current name.
   * @example "Generali"
   */
  party?: string;
  /**
   * Transfer party, as entered by the user
   * @example "SK3502000000000048134112"
   */
  rawParty?: string;
  /**
   * Transfer payment type
   * @example "Debit"
   */
  type?: UpdateTransferDtoTypeEnum;
}

/**
 * Transfer payment type
 * @example "Debit"
 */
export enum UpdateTransferDtoTypeEnum {
  Debit = "Debit",
  Credit = "Credit",
}

export interface UpdateTransferRecordDto {
  /**
   * Uuid of the category to assign to this record
   * @example "00000000-0000-0000-0000-000000000000"
   */
  categoryId?: string;
  /**
   * Comma separated description of this record
   * @example "Netflix, Subscription"
   */
  description?: string;
}

export interface UserDto {
  /**
   * Date of creation
   * @format date-time
   */
  createdAt: string;
  /**
   * User email
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * User profile image url
   * @example "https://"
   */
  image: string | null;
  /**
   * User name
   * @example "John Doe"
   */
  name: string | null;
  /**
   * Date of update
   * @format date-time
   */
  updatedAt: string;
  /**
   * Uuid for finding
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string;
}

export interface VersionResponseDto {
  /**
   * API version
   * @example "1.0.0"
   */
  api: string;
  /**
   * Node environment
   * @example "local"
   */
  env: string;
  /**
   * API package name
   * @example "expenses-mapper-core"
   */
  name: string;
}
